import { render, staticRenderFns } from "./OrdenDeServicioRow.vue?vue&type=template&id=6891b4a4"
import script from "./OrdenDeServicioRow.vue?vue&type=script&lang=js"
export * from "./OrdenDeServicioRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports